/*@ngInject*/
module.exports = function($rootScope, $uibModalInstance, data) {
    const vm = this;

    vm.object = data;
    vm.modalInstace = $uibModalInstance;

    vm.close = () => {
        $rootScope.isModalOpen = false;
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-map-modal.directive.js
 **/